// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DbA05d0FT8yN8z {
  height: 32px;
  margin-right: 4px;
  margin-bottom: 0px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"joinButton": `DbA05d0FT8yN8z`
};
export default ___CSS_LOADER_EXPORT___;
